<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from "vue";

import BaseModal from "@/components/BaseModal/index.vue"
import { useShippingMethod } from "@/composables/useShippingMethod"
import NBRadioGroup from "@/app/Checkout/components/common/NBRadioGroup/index.vue"

const isModalOpen = ref(false)
const { shippingMethods, selectedShippingMethod, selectedShippingLabel } = useShippingMethod()
const openOverlay = () => {
  isModalOpen.value = true
}
const handleSelect = (val) => {
  isModalOpen.value = false
  selectedShippingMethod.value = val
}
</script>
